module.exports = __webpack_public_path__ + "img/header-memoireRingsExclusive@2x.d67ad3a.jpg";